import { array } from '@mojotech/json-type-validation'

import { ArenaProblemElement } from '@/domain/entities/arena/arenaProblemElement'
import { ArenaUserEntry } from '@/domain/entities/arena/arenaUserEntry'
import { ArenaUserSubmission } from '@/domain/entities/arena/arenaUserSubmission'
import { ArenaRepository } from '@/domain/repositories/arena/ArenaRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { arenaProblemElementDecoder } from '@/infrastructure/decoders/arena/arenaProblemElementDecoder'
import { arenaUserEntryDecoder } from '@/infrastructure/decoders/arena/arenaUserEntryDecoder'
import { arenaUserSubmissionDecoder } from '@/infrastructure/decoders/arena/arenaUserSubmissionDecoder'

export class ArenaRepositoryImpl implements ArenaRepository {
  constructor(private clients: ApiClients) {}

  async getByUserIdArenaEntryList(userId: string): Promise<ArenaUserEntry[]> {
    const path = `arenas/entries/users/${userId}`
    const data = await this.clients.aojClient.fetchAndDecode(array(arenaUserEntryDecoder), path)
    return data
  }

  async getByArenaIdProblemList(arenaId: string): Promise<ArenaProblemElement[]> {
    const path = `arenas/${arenaId}/problems`
    const data = await this.clients.aojClient.fetchAndDecode(array(arenaProblemElementDecoder), path)
    return data
  }

  async getByUserIdArenaSubmissionList(arenaId: string, userId: string): Promise<ArenaUserSubmission[]> {
    const path = `/arenas/${arenaId}/submissions/users/${userId}`
    const data = await this.clients.aojClient.fetchAndDecode(array(arenaUserSubmissionDecoder), path)
    return data
  }
}
